import { render, staticRenderFns } from "./SwitchBrand.vue?vue&type=template&id=04df5e1e&scoped=true&"
import script from "./SwitchBrand.vue?vue&type=script&lang=ts&"
export * from "./SwitchBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df5e1e",
  null
  
)

export default component.exports